import md5 from 'md5';

// 返回签名
function getSign(DATA_ARR: any) {
  let sign = [];
  let salt = 'f3e292b242ab';
  let timeStamp = new Date().getTime();

  sign.push(salt);
  sign.push(timeStamp);

  Object.keys(DATA_ARR).forEach(key => {
    sign.push(DATA_ARR[key]);
  });

  sign = sign.sort();
  return [md5(sign.join('')), timeStamp];
}

function getSignZwzt(DATA_ARR: any) {
  let sign = [];
  let salt = 'f3e292b242ab';
  let timeStamp = new Date().getTime();

  sign.push(salt);
  sign.push(timeStamp);

  Object.keys(DATA_ARR).forEach(key => {
    sign.push(DATA_ARR[key]);
  });

  sign = sign.sort();
  return [md5(sign.join('')), timeStamp];
}

export default { getSign, getSignZwzt };
